import { useTranslation } from 'react-i18next'
import { StyledGrid } from '../styled-components/styles'

export type QuoteItemData = {
  brand?: string | null
  modelName?: string | null
  category?: string | null
  manufactureYear?: number | null
  stockType?: string | null
}

export const QuoteItemsGrid = ({
  data,
  keyPrefix
}: {
  data: QuoteItemData[]
  keyPrefix: string
}) => {
  const { t } = useTranslation('', {
    keyPrefix
  })

  return (
    <StyledGrid
      columnsProps={[
        {
          allowHeaderFiltering: true,
          caption: `${t('brand')}`,
          dataField: 'brand'
        },
        {
          allowHeaderFiltering: true,
          caption: `${t('modelName')}`,
          dataField: 'modelName'
        },
        {
          allowHeaderFiltering: true,
          caption: `${t('category')}`,
          dataField: 'category'
        },
        {
          allowHeaderFiltering: true,
          caption: `${t('manufactureYear')}`,
          dataField: 'manufactureYear'
        },
        {
          allowHeaderFiltering: true,
          caption: `${t('stockType')}`,
          dataField: 'stockType'
        }
      ]}
      filterRow={{
        visible: false
      }}
      headerFilter={{
        visible: true
      }}
      pagerProps={{
        visible: true
      }}
      remoteOperations={true}
      scrolling={{
        useNative: true
      }}
      searchPanelProps={{
        highlightSearchText: true,
        visible: true
      }}
      allowColumnResizing={true}
      columnAutoWidth={true}
      dataSource={data}
      filterSyncEnabled={false}
      headerFilterProps={{ visible: true }}
      noDataText="no data"
    />
  )
}
